import { toDate } from "./toDate.js";

import { getMonth as coreGetMonth } from "./_core/getMonth.js";

/**
 * The {@link getQuarter} function options.
 */

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2));
 * //=> 3
 */
export function getQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const quarter = Math.trunc(coreGetMonth(_date) / 3) + 1;
  return quarter;
}

// Fallback for modularized imports:
export default getQuarter;
